import { createSelector } from 'reselect';
import { FeatureFlags } from '../../feature-flags/feature-flags';
import { UspsWalletService } from '../../enums/label-providers/usps/usps-wallet-service';

const uspsServiceIdsEligibleForRecommendations = [
  UspsWalletService.FirstClassMail,
  UspsWalletService.ParcelSelect,
  UspsWalletService.PriorityMail,
  UspsWalletService.GroundAdvantage,
];

// These flags control which services can show recommendations for a single fulfillment plan.
// Bulk recommendations are controlled by corresponding BE flags (EnableRateRecommendationsForServices,
// EnableRateRecommendationsForFedexServices). Keep these in sync. Ideally the FE flags are removed
// in favor of the BE flags handling both single and bulk recommendations.
// enableUspsRateComparison has no corresponding BE flag — it's only disabled for a single customer
// who also has the FedEx flag disabled. We can likely move them to the flag that hides
// recommendations altogether and remove the USPS flag and hardcoded service array.
export const serviceIdsEligibleForRecommendationsSelector = createSelector(
  (state) => new FeatureFlags({ state }).enableUspsRateComparison,
  (state) => new FeatureFlags({ state }).enableRateRecommendationsForServices,
  (state) => new FeatureFlags({ state }).enableRateRecommendationsForFedexServices,
  (enableUspsRateComparison, enableRateRecommendationsForServices, enableRateRecommendationsForFedexServices) => {
    return [
      ...(enableRateRecommendationsForServices?.ServiceIds ?? []),
      ...(enableUspsRateComparison ? uspsServiceIdsEligibleForRecommendations : []),
      ...(enableRateRecommendationsForFedexServices?.ServiceIds ?? []),
    ];
  },
);
